
const ASSO_TYPE = 'asso'
const PLACE_TYPE = 'place'
const ADS_MAKER_TYPE = 'ads-maker'

const ProTypeOptions = [
  { value: 'asso', label: "Association" },
  { value: 'place', label: 'Etablissement' },
  { value: 'ads-maker', label: 'Annonceurs' },
]

export {
  ASSO_TYPE,
  PLACE_TYPE,
  ADS_MAKER_TYPE,

  ProTypeOptions
}